<template>
  <div class="material3D">
    <div ref='container3D' class="container3D"></div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import * as Three from 'three'
import { OBJLoader } from '@shared/assets/libs/OBJLoader.js';
import { OrbitControls } from '@shared/assets/libs/OrbitControls.js';

export default {
  name: 'Material3D',
  data() {
    return {
    };
  },
  props: ['objectUrl'],
  mounted() {
    // this.init();

    this.init3D();
    this.animate3D();
  },
  methods: {
    // init() {
    //   this.this.scene = new THREE.Scene();
    //   this.this.camera = new THREE.OrthographicCamera(...);
    //
    //   this.this.renderer = new THREE.WebGLRenderer({ ... })
    //   this.geometry = new THREE.PlaneBufferGeometry(  );
    //   const material = new THREE.MeshBasicMaterial({ color: 0xff0000 });
    //
    //   this.plane = new THREE.Mesh(this.geometry, material);
    //
    //   this.this.scene.add(this.plane);
    //
    //   this.this.renderer.render(this.this.scene, this.this.camera);
    // },
    init3D: function() {
        // console.log('initializing 3D block ')
        let container = this.$refs.container3D;

        let width = 200;
        let height = 200;
        width = container.clientWidth;
        height = container.clientHeight
        // console.log('container size: ', width, height);

        // this.camera = new Three.PerspectiveCamera(70, width/height, 0.01, 10);
        // this.camera.position.z = 1;

        this.camera = new Three.PerspectiveCamera( 45, width / height, 1, 2000 );
				this.camera.position.z = 250;

        this.scene = new Three.Scene();

        const ambientLight = new Three.AmbientLight( 0xcccccc, 0.4 );
				this.scene.add( ambientLight );

				const pointLight = new Three.PointLight( 0xffffff, 0.8 );
				this.camera.add( pointLight );
				this.scene.add( this.camera );


        let loader = new OBJLoader();
        let urlToLoad = this.objectUrl;
        // console.log('url to load: ', urlToLoad)

        // let urlToLoad = '/male02.obj';

        loader.load(urlToLoad, (loadedObject) => {
          this.obj = loadedObject;

          let objBoundingBox = new Three.Box3().setFromObject(this.obj)
          let boxSize = new Three.Vector3();
          objBoundingBox.getSize(boxSize);
          // console.log("BoxSize: ", boxSize);

          // scaleFactor = otherSize.x / mySize.x
          // this.obj.scale(scaleFactor, scaleFactor, scaleFactor)

          this.obj.position.y = - 95;
          this.scene.add(this.obj);
        },(xhr) => {
          // console.log('loading: ', xhr)
        },(error) => {
          // console.log('init3D error', error)
        })

        let geometry = new Three.BoxGeometry(0.2, 0.2, 0.2);
        let material = new Three.MeshNormalMaterial();

        this.mesh = new Three.Mesh(geometry, material);
        // this.scene.add(this.mesh);


        this.renderer = new Three.WebGLRenderer({antialias: true, alpha: true});
        this.renderer.setSize(width, height);
        container.appendChild(this.renderer.domElement);

        this.controls = new OrbitControls(this.camera, this.renderer.domElement)

    },
    animate3D: function() {
        requestAnimationFrame(this.animate3D);
        this.mesh.rotation.x += 0.01;
        this.mesh.rotation.y += 0.02;
        this.renderer.render(this.scene, this.camera);
    },
  }
}
</script>

<style>

  .material3D {
    width: 100%;
    height: 100%;
  }

  .container3D {
    width: 100%;
    height: 100%;
  }
</style>
